<template>
  <v-list class="lang" ref="langMenu" v-observe-visibility="visible=>hideLangs(visible)" >
    <v-list-tile @click="locale('es-ES')" :class="{'selected': $i18n.locale === 'es-ES'}">
      <v-list-tile-content>
        <v-list-tile-title>Bienvenido</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile @click="locale('eu-ES')" :class="{'selected': $i18n.locale === 'eu-ES'}">
      <v-list-tile-content>
        <v-list-tile-title>Ongi etorri</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile @click="locale('ca-ES')" :class="{'selected': $i18n.locale === 'ca-ES'}">
      <v-list-tile-content>
        <v-list-tile-title>Benvingut</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile @click="locale('en-US')" :class="{'selected': $i18n.locale === 'en-US'}">
      <v-list-tile-content>
        <v-list-tile-title>Welcome</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile @click="locale('it-IT')" :class="{'selected': $i18n.locale === 'it-IT'}">
      <v-list-tile-content>
        <v-list-tile-title>Benvenuto</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile @click="locale('fr-FR')" :class="{'selected': $i18n.locale === 'fr-FR'}">
      <v-list-tile-content>
        <v-list-tile-title>Bienvenue</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>


<script>
  import Api from '~/store/idonia-api/api'
  import {useBusUtils} from '~/commons/busUtils'
  import bus from '~/bus'
  import i18n from '~/i18n'

const { BusHandlerManager } = useBusUtils()
  export default {
    name: 'platform-actions',
    computed: {
      isAuthenticated: function () {
        return this.$store.getters['session/isAuthenticated']
      },
      accountID () {
        return this.$store.state.session.accountId
      },
      langMenu: function () {
        return this.$refs.langMenu
      }
    },
    data () {
      return {
        bhm: new BusHandlerManager()
      }
    },
    methods: {
      hideLangs (visible) {
        if (!visible) {
          this.espActive = false
          this.catActive = false
        }
      },
      locale (locale) {
        this.espActive = false
        this.$store.dispatch('session/locale', locale)
        this.$i18n.locale = locale
        this.$moment.locale(locale.slice(0, 2))
        if (this.isAuthenticated) {
          Api.putV2('account/' + this.accountID, {data: {preferred_lang: locale}})
            .then(() => {
              this.$store.dispatch('session/loadAccountData')
              bus.$emit('reloadAccountInfo')
              bus.$emit('analytics', {
                action: 'change-language',
                arguments: {
                  lang: locale
                }
              })
            })
        }
      }
    },
    mounted () {
      this.bhm.addHandler(bus, 'updateLocale', (locale) => {
        if (this) {
          this.$i18n ? this.$i18n.locale = locale : i18n.locale = locale
          if (this.$moment) this.$moment.locale(locale.slice(0, 2))
        }
      })
    },
    deleted () {
      this.bhm.cleanAll()
    }
  }
</script>
<style>
  .list__tile {
    padding: 0 2em;
  }
  .selected .list__tile__title {
    color: var(--primary_text);
  }
  .menu__content{
    margin-top: 25px;
    width: fit-content;
  }
</style>



// WEBPACK FOOTER //
// src/components/header/lang/ShortLangMenu.vue